import { render, staticRenderFns } from "./show-fournisseur.html?vue&type=template&id=56313144&scoped=true&external"
import script from "./show-fournisseur.js?vue&type=script&lang=js&external"
export * from "./show-fournisseur.js?vue&type=script&lang=js&external"
import style0 from "./show-fournisseur.scss?vue&type=style&index=0&id=56313144&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56313144",
  null
  
)

export default component.exports